import Swiper, { Autoplay, Keyboard, Navigation, Pagination } from "swiper";

Swiper.use([Navigation, Pagination, Autoplay, Keyboard]);

const swBreakPoint = 1200;

const sliders = document.querySelectorAll(".main-slider__swiper-container");
sliders.forEach((slider) => {
  const sliderID = `#${slider.parentNode.id}`;
  const slidesCount = document.querySelector(sliderID).dataset.slidesCount;

  if (slidesCount < 2) return;

  const swiperBullets = document.querySelector(
    `${sliderID} .main-slider-bullets`
  );
  const swOptions = {
    direction: getDirection(),
    slidesPerView: 1,
    loop: true,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: `${sliderID} .arrow--right-ms`,
      prevEl: `${sliderID} .arrow--left-ms`,
    },
    pagination: {
      el: `${sliderID} .main-slider-bullets`,
      clickable: true,
    },
    on: {
      resize: function () {
        swiperMainSlider.changeDirection(getDirection());
      },
    },
  };

  const swiperMainSlider = new Swiper(
    `${sliderID} .main-slider__swiper-container`,
    swOptions
  );

  window.addEventListener("resize", () => {
    const windowSize = window.innerWidth;

    if (windowSize <= swBreakPoint && swiperBullets !== null) {
      // swiperBullets.classList.add('swiper-pagination-horizontal');
      swiperBullets.classList.remove("swiper-pagination-vertical");
      return;
    }

    if (windowSize > swBreakPoint && swiperBullets !== null) {
      // swiperBullets.classList.remove('swiper-pagination-horizontal');
      swiperBullets.classList.add("swiper-pagination-vertical");
      return;
    }
  });
});

function getDirection() {
  return window.innerWidth <= swBreakPoint ? "horizontal" : "vertical";
}
